(function() {
  if (window.__cgPreviewInit) return;
  window.__cgPreviewInit = true;

  var currentAudio = null;
  var currentBtn = null;

  function resetBtn(btn) {
    if (!btn) return;
    var playIcon = btn.querySelector('.cg-preview-btn__play');
    var pauseIcon = btn.querySelector('.cg-preview-btn__pause');
    if (playIcon) playIcon.hidden = false;
    if (pauseIcon) pauseIcon.hidden = true;
    btn.setAttribute('aria-label', 'Play audio preview');
  }

  function stopCurrent() {
    if (currentAudio) {
      currentAudio.pause();
      currentAudio.currentTime = 0;
      currentAudio = null;
    }
    resetBtn(currentBtn);
    currentBtn = null;
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.cg-preview-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var url = btn.dataset.previewSrc;
    if (!url) return;

    if (currentBtn === btn && currentAudio && !currentAudio.paused) {
      stopCurrent();
      return;
    }

    stopCurrent();

    var audio = new Audio(url);
    currentAudio = audio;
    currentBtn = btn;

    var playIcon = btn.querySelector('.cg-preview-btn__play');
    var pauseIcon = btn.querySelector('.cg-preview-btn__pause');
    if (playIcon) playIcon.hidden = true;
    if (pauseIcon) pauseIcon.hidden = false;
    btn.setAttribute('aria-label', 'Pause audio preview');

    audio.addEventListener('ended', function() { stopCurrent(); });
    audio.addEventListener('error', function() { stopCurrent(); });
    audio.play().catch(function() { stopCurrent(); });
  }, true);
})();
